"use strict";
$(function ($) {
  /* ドロワーメニュー */
   /* ----- 簡単なハンバーガーメニュー ----- */
  $('#js-hamburger').on('click', function () {
    $('#js-hamburger, #js-drawer-menu').toggleClass('is-openSP');
  });

  $("#js-hamburger").click(function () {
    $(this).toggleClass('active');
  });

  // ハンバーガーメニュー内をクリックしらたらハンバーガーメニューを閉じる
  $('#js-drawer-menu a[href]').on('click', function () {
    $('#js-hamburger').trigger('click')
  });
});

/* ----- qa ----- */
$(".qa__question").on("click", function() {
  $(this).next().slideToggle();
  $(this).toggleClass("is-active");
});

$(".megaMenu__btn").on("click", function() {
  $(this).next().slideToggle();
  $(this).toggleClass("is-active");
});


// document.addEventListener('DOMContentLoaded', () => {
//   const menuBtn = document.querySelector('.menu__btn');
//   const menuItems = menuBtn.querySelector('.menu__items');

//   menuBtn.addEventListener('mouseenter', () => {
//     menuItems.classList.add('is-active');
//   });

//   menuBtn.addEventListener('mouseleave', () => {
//     menuItems.classList.remove('is-active');
//   });
// });


// document.addEventListener('DOMContentLoaded', function() {
//     const menuBtn = document.querySelector('.menu__btn');
//     const menu = document.querySelector('.menu');
//     menuBtn.addEventListener('click', function() {
//         menuBtn.classList.toggle('is-active');
//         menu.classList.toggle('is-active');
//     });
// });



const swiper = new Swiper('.swiper', {
    slidesPerView: 1,
    spaceBetween: 10,
    centeredSlides: true,
    loop: true,
    speed: 1200, // スライド切り替えの速度（ミリ秒）
    autoplay: {
        delay: 5000,
        disableOnInteraction: false,
    },
    // pagination: {
    //     el: '.swiper-pagination',
    //     clickable: true,
    // },
    // navigation: {
    //     nextEl: '.swiper-button-next',
    //     prevEl: '.swiper-button-prev',
    // },
    breakpoints: {
        768: {
            slidesPerView: 1.2,
            spaceBetween: 30,
        },
    }
});



// /* ----- スライダー ----- */
// document.addEventListener('DOMContentLoaded', function () {
//   // voice__sliderの設定
//   const voiceSlider = document.querySelector('.voice__slider');
//   if (voiceSlider) {
//     new Splide('.voice__slider', {
//       type: 'loop',
//       pauseOnHover: false,
//       pauseOnFocus: false,
//       interval: 2000,
//       speed: 1000,
//       padding: '15%',
//       gap: 30,
//       pagination: false,
//       breakpoints: {
//         768: {
//           padding: '10%',
//           gap: 20,
//         },
//       },
//     }).mount();
//   } else {
//     console.log('voice__slider element not found');
//   }
// });


/* ----- スムースクロール ----- */
// 固定ヘッダー（固定しない場合は = 0）
const headerHeight = document.querySelector('header').getBoundingClientRect().height;
// スマホサイズの時の追加オフセット（必要に応じて調整）
const mobileOffset = -10; // 10px 追加オフセット
// PCサイズの時の追加オフセット（必要に応じて調整）
const pcOffset = -50; // 5px 上に調整

// ページ内のスムーススクロール
for (const link of document.querySelectorAll('a[href*="#"]')) {
  link.addEventListener('click', (e) => {
    const hash = e.currentTarget.hash;
    const target = document.getElementById(hash.slice(1));

    // ページトップへ("#"と"#top"）
    if (!hash || hash === '#top') {
      e.preventDefault();
      window.scrollTo({
        top: 1, // iOSのChromeで固定ヘッダーが動くバグがあるため0ではなく1に
        behavior: 'smooth',
      });

    // アンカーへ
    } else if (target) {
      e.preventDefault();
      let position = target.getBoundingClientRect().top + window.scrollY - headerHeight;

      // スマホサイズの場合の追加オフセット
      if (window.innerWidth <= 768) { // 768px 以下をスマホと判断
        position += mobileOffset;
      } else {
        // PCサイズの場合の追加オフセット
        position += pcOffset;
      }

      window.scrollTo({
        top: position,
        behavior: "smooth",
      });

      // URLにハッシュを含める
      history.pushState(null, '', hash);
    }
  });
};
